/** Browser entry: mount the app. Everything else lives in App.tsx (docs/11-web §2.1). */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import { registerServiceWorker } from './services/serviceWorker.js';
import './app.css';

const host = document.getElementById('root');
if (host === null) throw new Error('Thiếu phần tử #root trong index.html');

createRoot(host).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/* Chỉ để trình duyệt mời "Cài ứng dụng" — service worker này không cache gì (docs/13-tasks/01-ui-chrome.md#17). */
registerServiceWorker();
